import { render } from "./ComponentFooter.vue?vue&type=template&id=efd1e2ce&scoped=true"
import script from "./ComponentFooter.vue?vue&type=script&lang=js"
export * from "./ComponentFooter.vue?vue&type=script&lang=js"

import "./ComponentFooter.vue?vue&type=style&index=0&id=efd1e2ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd1e2ce"]])

export default __exports__